import { ref, onMounted, onUnmounted } from 'vue';

export function useIntersectionObserver(targetRef, options = {
	rootMargin: "100px 0px",
	threshold: 0.5
}, delay = 700) {
	const isVisible = ref(false);
	let observer;
	let debounceTimeout;

	const callback = ([entry]) => {
		clearTimeout(debounceTimeout); // Clear any ongoing debounce
		debounceTimeout = setTimeout(() => {
			if (entry.isIntersecting) {
				isVisible.value = true;
				if (targetRef.value && observer) {
					observer.unobserve(targetRef.value); // Stop observing if needed
				}
			}
		}, delay);
	};

	onMounted(() => {
		observer = new IntersectionObserver(callback, options);
		if (targetRef.value) {
			observer.observe(targetRef.value);
		}
	});

	onUnmounted(() => {
		clearTimeout(debounceTimeout);
		if (observer && targetRef.value) {
			observer.unobserve(targetRef.value);
		}
	});

	return { isVisible };
}
